module.exports = __webpack_public_path__ + "img/bg9.b447fe93.png";